/**
 * Cross-tree portal targets for Packers Android chrome (London Smoke & Cure).
 * AdminHamburgerNav lives outside the layout provider — registry bridges both.
 */

/** @type {Record<string, HTMLElement|null>} */
let slots = {
    sections: null,
    scales: null,
    quickBar: null,
    qr: null,
    menu: null,
};

/** @type {Set<() => void>} */
const listeners = new Set();

export function setPackersToolbarSlot(name, node) {
    if (!name || slots[name] === node) return;
    slots[name] = node;
    listeners.forEach((listener) => listener());
}

export function getPackersToolbarSlot(name) {
    return name ? slots[name] || null : null;
}

export function subscribePackersToolbarSlots(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}

export function clearPackersToolbarSlots() {
    slots = {
        sections: null,
        scales: null,
        quickBar: null,
        qr: null,
        menu: null,
    };
    listeners.forEach((listener) => listener());
}

export function getPackersToolbarSlotSnapshot(name) {
    return getPackersToolbarSlot(name);
}
